import axios from "axios"
import * as toastr from 'toastr'
import 'toastr/build/toastr.min.css'


toastr.options.timeOut = 5000;
toastr.options.positionClass = 'toast-bottom-center';
toastr.options.toastClass="toast1-class";
toastr.options.preventDuplicates = true;

export function errorToastr(text,time,size){
  clearToastr()
  if(time){
    toastr.options.timeOut = time
  }
  if(size){
    toastr.options.toastClass=`${size == 'big'? 'toast1-class-bigger-font' : ''}`
  }
  toastr.remove()
  toastr.error(text)
}
export function successToastr(text,time){
  clearToastr()
  if(time){
    toastr.options.timeOut = time
  }
  toastr.success(text);
}
export function clearToastr(){
  toastr.clear();
}


